import type { Course, Enrollment, LeaderboardEntry, Lesson } from '@/types/models';
import { api } from '@/lib/firebase/api';

export const fetchCourses = () => api<Course[]>('/courses');
export const fetchCourse = (id: string) => api<Course>(`/courses/${id}`);
export const fetchCourseBySlug = (slug: string) => api<Course>(`/courses/slug/${slug}`);
export const fetchLessons = (courseId: string) => api<Lesson[]>(`/courses/${courseId}/lessons`);
export const fetchLesson = (courseId: string, lessonId: string) =>
  api<Lesson>(`/courses/${courseId}/lessons/${lessonId}`);

export const enrollInCourse = (courseId: string) =>
  api<Enrollment>('/enrollments', { method: 'POST', body: JSON.stringify({ courseId }) });

export const fetchEnrollment = (courseId: string) =>
  api<Enrollment | null>(`/enrollments?courseId=${courseId}`);

export const fetchMyEnrollments = () => api<Enrollment[]>('/enrollments');

export const fetchLeaderboard = (courseId: string) =>
  api<LeaderboardEntry[]>(`/courses/${courseId}/leaderboard`);

export const completeLesson = (enrollmentId: string, lessonId: string) =>
  api<Enrollment>(`/enrollments/${enrollmentId}/complete-lesson`, {
    method: 'POST',
    body: JSON.stringify({ lessonId }),
  });
